import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  sampleColorsContainer: {
    margin: "-2px -2px -2px 14px",
    width: 64,
  },
  input: {
    flexGrow: 1,
    flexBasis: 0,
  },
  preview: {
    width: 36,
    borderRadius: 5,
    borderColor: theme.palette.text.primary,
    borderWidth: 1,
    borderStyle: "solid",
  },
  block: {
    width: "calc(50% - 4px)", //32,
    height: 25,
    border: "1px solid " + theme.palette.text.primary + "26",
    borderRadius: 5,
    boxSizing: "border-box",
    margin: 2,
    cursor: "pointer",
  },
  saturation: {
    position: "relative",
    overflow: "hidden",
    width: 228,
    height: 228,
    borderRadius: 5,
  },
  pointerHue: {
    overflow: "hidden",
    marginLeft: 16,
    borderRadius: 5,
    "& .rc-hue-control__pointer": {
      left: "auto !important",
      right: 0,
    },
  },
  acceptButtonContainer: {
    borderTop: `1px solid ${theme.props.border}`,
    padding: 16,
  }
}));

export default useStyle;
